'use strict';

var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var PdfRenderableSplitRow = function PdfRenderableSplitRow(_ref) {
  var leftContent = _ref.leftContent,
      rightContent = _ref.rightContent;
  return React__default["default"].createElement("div", {
    style: {
      display: '-webkit-box'
    }
  }, React__default["default"].createElement("div", {
    style: {
      WebkitBoxFlex: 1
    },
    align: "left"
  }, leftContent), React__default["default"].createElement("div", {
    style: {
      WebkitBoxFlex: 0,
      marginTop: 'auto'
    },
    align: "right"
  }, rightContent));
};

module.exports = PdfRenderableSplitRow;
